module.exports = __webpack_public_path__ + "img/united_arab_emirates.edaf432.webp";